// getDefaultExport function for compatibility with non-harmony modules
__webpack_require__.n = (module) => {
	const getter = module && module.__esModule ?
		() => (module['default']) :
		() => (module);
	__webpack_require__.d(getter, { a: getter });
	return getter;
};